import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withRouterConfig } from '@angular/router';
import { environment } from '@env/environment';
import { routes } from '@portal-status/app/app.routes';
import { AppComponent } from '@portal-status/app/components/app-root/app.component';
import { provideCore } from '@portal-status/core/core.providers';
import { provideStatusIcons } from '@portal-status/status/status-icons.providers';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    ...provideCore(),
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideStatusIcons()
  ]
})
  .catch(err => console.error(err));
